import { Stack, Typography } from '@mui/material';
import { Show, useIsMobile } from '@side/pantry';
import Image, { type StaticImageData } from 'next/image';
import BuyerAgreementIllustration from 'public/img/illustrations/document-with-pen.svg';

export const NewBuyerPrepareToSend = () => {
  const isMobile = useIsMobile('lg');

  return (
    <Stack sx={{ flexDirection: 'row', gap: 2 }}>
      <Stack sx={{ gap: { xs: 2, lg: 3 } }}>
        <Typography variant={isMobile ? 'body3' : 'body2'}>
          When you continue, your Offer will be created and automatically linked
          to your new Buyer. You will be routed to your Buyer to send your
          agreement for signature.
        </Typography>
        <Typography
          variant={isMobile ? 'body3' : 'body2'}
          sx={{ color: 'text.secondary' }}
        >
          Note that a signed Buyer Agreement will be required in order to send
          the offer to a listing agent. You’ll have the opportunity to send more
          documents once the Offer is created.
        </Typography>
      </Stack>
      <Show when={!isMobile}>
        <Image
          alt="document with pen"
          src={BuyerAgreementIllustration as StaticImageData}
        />
      </Show>
    </Stack>
  );
};
